// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BMrp","option":"styles_option__1YyJO","active":"styles_active__-jwa-"};